import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'man-field',
  templateUrl: './field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'form-field' },
  standalone: true,
  imports: [TranslateModule, CommonModule]
})
export class FieldComponent {
  @Input() public label?: string;
  @Input() public labelFor?: string;
  @Input() public helpText?: string;
  @Input() public errors?: ValidationErrors;
  @Input() public required?: boolean;

  public get describedById(): string | undefined {
    if (this.helpText === undefined || this.labelFor === undefined) {
      return;
    }

    return `${this.labelFor}-help`;
  }
}
